/**
 * Create a combined-discount promotion: name, image, combined condition (count + productIds), per-product discounts.
 * @param {Function} requestWithMeta - useHttp().requestWithMeta
 * @param {{ name: string, imageUrl: string | null, count: number, conditionProductIds: Array<number|string>, rewards: Array<{ productId: number|string, discount: number }> }} payload
 * @returns {Promise<{ ok: boolean, data?: any, status?: number }>}
 */
export async function createCombinedDiscountPromotion(requestWithMeta, payload) {
  const { name, imageUrl, count, conditionProductIds, rewards } = payload;

  const trimmedName = name?.trim() ?? '';
  const numericCount = Number(count);

  const conditionProductIdsClean = Array.isArray(conditionProductIds)
    ? conditionProductIds.filter((id) => id !== null && id !== undefined)
    : [];

  const rewardsClean = Array.isArray(rewards)
    ? rewards
        .filter((r) => r.productId != null && Number(r.discount) > 0)
        .map((r) => ({
          productId: r.productId,
          discount: Number(r.discount),
        }))
    : [];

  const body = {
    name: trimmedName,
    imageUrl: imageUrl?.trim?.() || null,
    conditions: [
      {
        typeId: 2, // COMBINED
        metaData: {
          count: numericCount,
          productIds: conditionProductIdsClean,
        },
      },
    ],
    rewards: rewardsClean,
  };

  const res = await requestWithMeta('/operator/promotions', 'POST', body);
  return { ok: res?.ok ?? false, data: res?.data, status: res?.status };
}

